// extracted by mini-css-extract-plugin
export default {"custom-labels-show-section":"custom-labels-show-section---Oz0Jj"};